import { Box } from '@chakra-ui/react';
import { memo } from 'react';
import { PcSideButtons } from '../../ui/ShopDetail/ShopDetailSubmit/PcSideButtons/PcSideButtons';
import {
  ContentWrapper,
  Pagination,
  PcDisplayBlock,
  SpDisplayBlock,
} from '@/components';
import {
  getPageInfo
} from '@/config/pages';
import { BlogList } from '@/features/blog/components/ui/BlogList/BlogList';
import { PcShopDetailBookingLink } from '@/features/shops/components/ui/ShopDetail/PcShopDetail/PcShopDetailBookingLink';
import { ShopDetailNavigation } from '@/features/shops/components/ui/ShopDetail/ShopDetailNavigation/ShopDetailNavigation';
import { SpShopDetailSubmitFooter } from '@/features/shops/components/ui/ShopDetail/ShopDetailSubmit/SpShopDetailSubmitFooter';
import { Title } from '@/features/shops/components/ui/ShopDetail/Title';
import { ShopForRerakuBlogQuery } from '@/graphql/generated/graphql';

type ShopDetailBlogProps = {
  shop: NonNullable<ShopForRerakuBlogQuery['shop']>;
}

export const ShopDetailBlog = memo(({
  shop
}: ShopDetailBlogProps) => {
  const {
    rerakuBlogs,
    name,
    messageFromShopHtml,
    isBookable,
    staffs,
    rerakuCourseCategories
  } = shop;
  return (
    <>
      <ShopDetailNavigation
        shop={shop}
        currentPage={5}
        isNullCourseFromShop={rerakuCourseCategories.length === 0}
        isNullStaffsFromShop={staffs.length === 0 || !isBookable}
        isNullMessageFromShop={messageFromShopHtml === null}
        isNullBlogFromShop={rerakuBlogs.items.length === 0}
      />
      <PcDisplayBlock>
        <PcSideButtons
          shop={shop}
        />
      </PcDisplayBlock>
      <ContentWrapper
        bg={'white'}
        pb={8}
      >
        <Title
          py={2}
          px={6}
          title={`${name}のブログ一覧`}
        />

        <Box
          my={3}
          mx={{ base: 6, md: 24 }}
        >
          <BlogList blogs={rerakuBlogs.items}/>
        </Box>

        <Pagination
          baseUrlPath={getPageInfo('studio/{slug}/blog', shop).href}
          pageInfo={rerakuBlogs.pageInfo}
          mt={8}
        />
      </ContentWrapper>

      {isBookable &&
        <PcDisplayBlock
          bg={'white'}
          pb={4}
        >
          <PcShopDetailBookingLink
            slug={shop.slug}
            name={shop.name}
            shopTel={shop.tel}
            isBookable={isBookable}
          />
        </PcDisplayBlock>
      }
      <SpDisplayBlock
        zIndex={'sticky'}
        position={'sticky'}
        bottom={0}
      >
        <SpShopDetailSubmitFooter
          shop={shop}
        />
      </SpDisplayBlock>
    </>
  );
});
ShopDetailBlog.displayName = 'ShopDetailBlog';
